var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("SVG图标组件")]),
      _c(
        "el-row",
        _vm._l(_vm.$IconSvg, function(icon, index) {
          return _c(
            "el-col",
            { key: index, staticClass: "icon-card", attrs: { span: 4 } },
            [
              _c("d2-icon-svg", { staticClass: "icon", attrs: { name: icon } }),
              _c("div", { staticClass: "icon-title" }, [
                _c("span", [_vm._v(_vm._s(icon))])
              ])
            ],
            1
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }